import { defineMessages } from 'react-intl';

const messages = defineMessages({
  greenStatusBenefitsTitle: {
    id: 'rewards.bentoBox.greenStatusBenefits.title',
    description: 'Title for Green status benefits bento box',
  },
  goldStatusBenefitsTitle: {
    id: 'rewards.bentoBox.goldStatusBenefits.title',
    description: 'Title for Gold status benefits bento box',
  },
  reserveStatusBenefitsTitle: {
    id: 'rewards.bentoBox.reserveStatusBenefits.title',
    description: 'Title for Reserve status benefits bento box',
  },
  earnStarsHeading: {
    id: 'rewards.bentoBox.earnStars.heading',
    description: 'Heading for earn stars benefit',
    defaultMessage: 'Earn 1★ for{br}every $1 spent',
  },
  goldEarnStarsHeading: {
    id: 'rewards.bentoBox.gold.earnStars.heading',
    description: 'Heading for Gold earn stars benefit',
    defaultMessage: 'Earn 1.2★ for{br}every $1 spent',
  },
  reserveEarnStarsHeading: {
    id: 'rewards.bentoBox.reserve.earnStars.heading',
    description: 'Heading for Reserve earn stars benefit',
    defaultMessage: 'Earn 1.7★ for{br}every $1 spent',
  },
  starsNeverExpireHeading: {
    id: 'rewards.bentoBox.starsNeverExpire.heading',
    description: 'Heading for stars never expire benefit',
    defaultMessage: 'Your Stars will{br}never expire',
  },
  birthdayTreatHeading: {
    id: 'rewards.bentoBox.birthdayTreat.heading',
    description: 'Heading for birthday treat benefit',
    defaultMessage: 'Celebrate your birthday with{br}a treat - on us!',
  },
  birthdayTreatBody: {
    id: 'rewards.bentoBox.birthdayTreat.body',
    description: 'Body text for birthday treat benefit',
    defaultMessage: 'Grab a free drink or bite—our treat!',
  },
  birthdayTreatSubtext: {
    id: 'rewards.bentoBox.birthdayTreat.subtext',
    description: 'Additional text for birthday treat benefit',
    defaultMessage:
      'Add your birthday and make at least one eligible transaction to redeem this perk',
  },
  freeMondayHeading: {
    id: 'rewards.bentoBox.freeMonday.heading',
    description: 'Heading for Free Mod Monday benefit',
    defaultMessage: 'Free{br}Mod Monday',
  },
  freeMondayBody: {
    id: 'rewards.bentoBox.freeMonday.body',
    description: 'Body text for Free Mod Monday benefit',
    defaultMessage: 'Add a customization to your drink—on us!',
  },
  learnMoreCta: {
    id: 'rewards.bentoBox.learnMore.cta',
    description: 'Learn more call to action text',
    defaultMessage:
      'Add your birthday and make at least one eligible transaction to redeem this perk',
  },
  redeemCta: {
    id: 'rewards.bentoBox.redeem.cta',
    description: 'Redeem call to action text',
    defaultMessage: 'Redeem',
  },
  // Gold status specific messages
  goldBirthdayTreatHeading: {
    id: 'rewards.bentoBox.gold.birthdayTreat.heading',
    description: 'Heading for Gold birthday treat benefit',
    defaultMessage: '7 days to redeem{br}your birthday treat!',
  },
  goldCardHeading: {
    id: 'rewards.bentoBox.goldCard.heading',
    description: 'Heading for Gold card benefit',
    defaultMessage: 'Our cherished{br}Gold Card is back!',
  },
  goldCardBody: {
    id: 'rewards.bentoBox.goldCard.body',
    description: 'Body text for Gold card benefit',
    defaultMessage:
      'Flex your status with a physical, metal card. Check your email to request yours today!',
  },
  // Reserve status specific messages
  reserveBirthdayTreatHeading: {
    id: 'rewards.bentoBox.reserve.birthdayTreat.heading',
    description: 'Heading for Reserve birthday treat benefit',
    defaultMessage: '30 days to redeem{br}your birthday treat!',
  },
  reserveCardHeading: {
    id: 'rewards.bentoBox.reserveCard.heading',
    description: 'Heading for Reserve card benefit',
    defaultMessage: 'Personalized{br}Reserve Card',
  },
  reserveCardBody: {
    id: 'rewards.bentoBox.reserveCard.body',
    description: 'Body text for Reserve card benefit',
    defaultMessage:
      'Check your email to request your personalized, metal Reserve card today!',
  },
  originCollectionHeading: {
    id: 'rewards.bentoBox.originCollection.heading',
    description: 'Heading for Origin Collection benefit',
    defaultMessage: 'Access to the{br}Origin Collection',
  },
  originCollectionBody: {
    id: 'rewards.bentoBox.originCollection.body',
    description: 'Body text for Origin Collection benefit',
    defaultMessage:
      'Consequat lacus feugiat vivamus curabitur aliquam tortor consectetur nisl.',
  },
  seeHowBenefitsGrow: {
    id: 'rewards.universalBenefitBox.seeHowBenefitsGrow',
    description: 'Text for see how benefits grow section',
    defaultMessage: 'See how benefits grow with your status',
  },
  compareStatusLevels: {
    id: 'rewards.universalBenefitBox.compareStatusLevels',
    description: 'Button text for compare status levels',
    defaultMessage: 'Compare status levels',
  },
});

export default messages;
